import { render, staticRenderFns } from "./RiskMitigationROITable.vue?vue&type=template&id=4727a879&scoped=true&"
import script from "./RiskMitigationROITable.vue?vue&type=script&lang=js&"
export * from "./RiskMitigationROITable.vue?vue&type=script&lang=js&"
import style0 from "./RiskMitigationROITable.vue?vue&type=style&index=0&id=4727a879&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4727a879",
  null
  
)

export default component.exports